import { render, staticRenderFns } from "./MpPrivacy.vue?vue&type=template&id=69fed2de&"
import script from "./MpPrivacy.vue?vue&type=script&lang=js&"
export * from "./MpPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./MpPrivacy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports